import Header from "./Header"

export const SideBar = () => {
  return (
    <>
      <div className="lg:block sm:hidden md:hidden hidden">
        <div className="flex flex-col justify-between h-[466px]">
          <Header />
          <div>
            <div
              className="text-gray-500 mb-5 max-w-[240px]"
              style={{ fontSize: '14px', textAlign: "left" }}
            >
              <span style={{fontSize: '35px', marginRight: '5px' , fontFamily: "Tangerine, serif", lineHeight: '10px'}}
              >
                A
              </span>
              <span style={{fontStyle : 'italic'}}>
              fiercely passionate artist trained in Fine Arts from India and the USA,
              Paramita is offering a bunch of her best works through this website. Let’s
              take a trip to her creative endeavours with profound excitements.
              </span>
             
            </div>
            <div className="font-bold text-gray-500 text-2xl">
              Paramita Chakraborty
            </div>
          </div>
        </div>
      </div>
    </>
  )
}